import { createRequestedDebugInfoOutbound } from '../api/outbound/commonOutbounds';
import { getDeviceDetectInfo } from './deviceDetectUtils';
import { getFpsStats } from './fpsUtils';
import { getAnimationCount } from './pixiUtils';
import { getBuildTime, getBuildTimestamp } from './versionUtils';
import { getGitCommit } from './versionUtils';
export const ALL_DEBUG_INFO_SESSION_STATS = ['Hidden Page Layout Mode Checks'];
// SINGLETON ALERT!
export const debugInfoSessionStats = {
    'Hidden Page Layout Mode Checks': 0
};
function getDebugInfo(store) {
    const state = store.getState();
    const fields = { ...getDeviceDetectInfo() };
    const fpsStats = getFpsStats();
    if (fpsStats) {
        fields['Average FPS'] = fpsStats.averageFps;
        fields['Num FPS Samples'] = fpsStats.fpsSamples.length;
    }
    fields['Animation Count'] = getAnimationCount(state.instanceId.instanceId);
    fields['Scene'] = state.scene.sceneType;
    fields['Panel'] = state.panels.activePanelType || 'off';
    fields['User Agent'] = navigator.userAgent;
    fields['Git Commit'] = getGitCommit();
    const buildTime = getBuildTime();
    if (buildTime) {
        fields['Build Time'] = buildTime;
    }
    const buildTimestamp = getBuildTimestamp();
    if (buildTimestamp) {
        fields['Build Timestamp'] = buildTimestamp;
    }
    fields['Page Visibility'] = document.visibilityState;
    Object.entries(debugInfoSessionStats).forEach(([name, value]) => {
        fields[name] = value;
    });
    fields['URL'] = window.location.href;
    return Object.keys(fields).reduce((acc, curr) => {
        const currValue = fields[curr];
        if (typeof currValue === 'number') {
            acc[curr] = `${currValue}`;
        }
        else if (typeof currValue === 'boolean') {
            acc[curr] = new Boolean(currValue).toString();
        }
        else {
            // string
            acc[curr] = currValue;
        }
        return acc;
    }, {});
}
export function handleDebugInfoRequest(inbound, store, socketSend) {
    socketSend(createRequestedDebugInfoOutbound(inbound.requestingAdminPlayerId, getDebugInfo(store)));
}
